/* @flow */
import React from 'react';
import { useSelector } from 'react-redux';
import { Container } from '../../../components/Layout/styles';
import {
	ImageWrapper,
	Section,
	ContainerIntro,
	TextWrapper,
	IntroImage,
	SubTitle,
	TitleH1,
	IntroBtnText,
} from '../styles';
import ServiceAdvantages from '../ServiceAdvantages';
import { IntroServicesImg, IntroServicesImg2x } from '../images';
import Button from '../../../components/Button2.0';

type TProps = {
	clickToServices: () => {},
};

const Intro = ({ clickToServices }: TProps) => {
	const isMobile: boolean = useSelector((state) => state.app.isMobile);

	return (
		<Section id="SectionIntro" type="intro">
			<Container>
				<ContainerIntro>
					<TextWrapper>
						<TitleH1>Новый стандарт покупки и продажи квартиры</TitleH1>
						<SubTitle>Полный спектр услуг. Технологично и надежно. Фиксированная цена</SubTitle>
					</TextWrapper>
					<Button
						onClick={clickToServices}
						id="buttonToServices"
						size={isMobile ? 's' : 'm'}
						style={{
							width: isMobile ? '100%' : 'max-content',
							padding: '0 46px',
							gridArea: 'btn',
						}}
					>
						<IntroBtnText>Купить квартиру</IntroBtnText>
					</Button>
					<ImageWrapper>
						<IntroImage src={IntroServicesImg} srcSet={`${IntroServicesImg2x} 2x`} alt="Услуги" />
					</ImageWrapper>
				</ContainerIntro>
				<ServiceAdvantages isMobile={isMobile} />
			</Container>
		</Section>
	);
};

export default Intro;
